import { React, useState, useEffect } from 'react'
import Dropdown from '../Components/Dropdown';
import { fetchData, PostData } from '../Services/httpHandelars'
import { useGlobalContext } from '../context'
import Snackbar from '../Components/Snackbar';
import Loader from '../Components/Loader';
import Pagination from '../Components/Pagination';



export default function Result() {
  const { setLoading, loading } = useGlobalContext();
  const [form, setForm] = useState({ startDate: "", endDate: "", controlName: "", analyzerName: "" })
  const [Control, setControlName] = useState([]);
  const [ControlData, setControlData] = useState([]);
  const [AnalyzerName, setAnalyzerName] = useState([]);
  const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" })
  const [results, setResults] = useState([])



  useEffect(
    () => {
      if (snacBar.snacStatus === true) {
        console.log(snacBar.snacStatus)
        setTimeout(() => setSnacBar(false), 2000);
      }
    },

    [snacBar.snacStatus]
  );

  useEffect(() => {
    fetchData("/api/getControlSetup").then((data) => {
      data = JSON.parse(data);
      const control = data.data;
      const Name = control.map(name => name?.ControlName)
      setControlData(control)
      setControlName(Name)
    }).catch(e => console.log(e));

    fetchData("/api/getAnalyzerSetup").then((data) => {
      data = JSON.parse(data);
      const Analyzer = (data.data);
      const Name = Analyzer.map(name => name?.AnalyzerName)
      setAnalyzerName(Name)
    }).catch(e => console.log(e));

  }, [])



  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }



  const handlsePageChange = (body) => {

    if (form.startDate && form.endDate && form.controlName && form.analyzerName) {
      const data = {
        startDate: form.startDate,
        endDate: form.endDate,
        controlName: form.controlName,
        analyzerName: form.analyzerName,
        skip: body.skip,
        limit: 25

      }

      PostData("/api/getControlResultsData", data)
        .then((data) => {

          if (data.status == true) {
            setSnacBar({
              ...snacBar,
              snacStatus: true,
              message: data.message,
              snackType: "Success"
            })
            setResults(data)


          } else {

            setSnacBar({
              ...snacBar,
              snacStatus: data.status,
              message: "Responce Failed",
              snackType: "Error"
            })
          }
        }).catch((err) => {


          setSnacBar({
            ...snacBar,
            snacStatus: true,
            message: "Responce Failed",
            snackType: "Error"
          })
        })
    } else {
      // setLoading(false)
      setSnacBar({
        ...snacBar,
        snacStatus: true,
        message: "Please Enter values to search",
        snackType: "warning"
      })

    }
  }

  const handleApply = () =>{
    setLoading(true)
    const Controller = ControlData.find((name)=>(name.ControlName===form.controlName))
    if (results.meanValue && results.standardDeviationValue) {
      const update = {
        standardDeviationValue: results.standardDeviationValue,  
        meanValue: results.meanValue,
        _id: Controller._id
      }
      
      PostData("/api/updateControlSetup", update).then((success) => {
          setLoading(false)
          if (success.status === true) {
              
              setSnacBar({
                  ...snacBar,
                  snacStatus: success.status,
                  message: success.message,
                  snackType: "Success"
              })
              // setForm({})

          } else {
              setLoading(false)

              setSnacBar({
                  ...snacBar,
                  snacStatus: success.status,
                  message: "Responce Failed",
                  snackType: "Error"
              })
          }
          // fetchData("/api/getAnalyzerSetup").then((success) => {
          //     const updateAnalyzerSetup = JSON.parse(success)
          //     setAnalyzerSetup(updateAnalyzerSetup)
          // })
      }).catch((err) => {
          setLoading(false)

          console.log("asd--->", err)
          setSnacBar({
              ...snacBar,
              snacStatus: true,
              message: "Response Failed",
              snackType: "Error"
          })
      })
  }
  }



  const handleSearch = () => {
    setLoading(true)
    if (form.startDate && form.endDate && form.controlName && form.analyzerName) {

      const Controller = ControlData.find((name)=>(name.ControlName===form.controlName))
      const data = {
        startDate: form.startDate,
        endDate: form.endDate,
        controlName: form.controlName,
        analyzerName: form.analyzerName,
        _id:Controller._id,
        skip: 0,
        limit: 25

      }

      PostData("/api/getControlResultsData", data)
        .then((data) => {
          setLoading(false)
          if (data.status == true) {
            setSnacBar({
              ...snacBar,
              snacStatus: data.status,
              message: "Successfully get result",
              snackType: "Success"
            })
            setResults(data)
          } else {
            setLoading(false)
            setSnacBar({
              ...snacBar,
              snacStatus: data.status,
              message: "Responce Failed",
              snackType: "Error"
            })
          }
        }).catch((err) => {
          setLoading(false)

          setSnacBar({
            ...snacBar,
            snacStatus: true,
            message: "Responce Failed",
            snackType: "Error"
          })
        })
    } else {
      setLoading(false)
      setSnacBar({
        ...snacBar,
        snacStatus: true,
        message: "Please Enter values to search",
        snackType: "warning"
      })

    }
  }

  return (
    <>
      {!loading ?
        <div className="flex justify-center">
          <div className='flex flex-col  w-9/12'>

            <div className='flex justify-start mt-20'>
              <div className="flex items-center">
                <div >
                  <label> Start Date</label>
                  <input value={form?.startDate} onChange={handleChange} name="startDate" type="date" className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date start" />
                </div>
                <span className="mx-4 mt-4 text-gray-500">to</span>
                <div >
                  <label>End Date</label>
                  <input name="endDate" value={form?.endDate} type="date" onChange={handleChange} className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Select date end" />
                </div>
                <div className='mt-8 ml-4'>
                  <Dropdown title={"Control Name"} options={Control} value={form.controlName} name={"controlName"} handleChange={handleChange} />
                </div>
                <div className='mt-8 ml-4 '  >
                  <Dropdown title={"Analyzer Name"} options={AnalyzerName} value={form.analyzerName} name={"analyzerName"} handleChange={handleChange} />
                </div>
                <div className='mt-4 ml-4'>
                  <button
                    onClick={handleSearch}
                    className='py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                  >
                    Search
                  </button>
                </div>
              </div>

            </div>

            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-20">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="py-3 px-6">
                    Date
                  </th>
                  <th scope="col" className="py-3 px-6">
                    Value
                  </th>

                </tr>
              </thead>
              <tbody>
                {
                  results?.ResultData?.map(result => (
                    <tr key={result?._id} className="bg-white border-b dark:border-gray-700 text-gray-700 font-medium h-12">
                      <>
                        <td className='px-6'>{new Date(result?.PerformedDateTime).toLocaleDateString()}</td>
                        <td className='px-6'>{result?.Result}</td>
                      </>
                    </tr>
                  ))
                }
                {results?.totalCount > 0 &&
                <tr className="bg-gray-500 border-b dark:border-gray-700 text-white font-medium h-12">
                  <>
                    <th scope="col" className=" py-3 px-6">
                    Mean 
                  </th>
                  <th scope="col" className="py-3 px-6">
                  {results.meanValue.toFixed(4)} 
                  </th>
                  </>
                </tr>
                }
                {results?.totalCount > 0 &&
                <tr className="bg-gray-500 border-b dark:border-gray-400 text-white font-medium h-12">
                  <>
                    <th scope="col" className=" py-3 px-6">
                    Standard Deviation 
                  </th>
                  <th scope="col" className="py-3 px-6">
                  {results.standardDeviationValue.toFixed(4)} 
                  </th>
                  </>
                </tr>
                }
         
                
              </tbody>
            </table>
              {results?.totalCount > 0 && <div className={"flex flex-col items-center p-2"}>
                  <button
                    onClick={handleApply}
                    className='py-2 px-4 w-32 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500'
                  >
                    Apply
                  </button>
                </div>}

            <div>
              <Pagination handlePageChange={handlsePageChange} total={results?.totalCount} page={Math.ceil(results?.totalCount / 25)} />
            </div>
          </div>
          {snacBar?.snacStatus &&

            <Snackbar snackType={snacBar?.snackType} message={snacBar.message} status={snacBar?.snacStatus} setSnacBar={setSnacBar} />
          }
        </div>
        : <Loader />}
    </>
  )
}
